'use client';

import { useTranslate } from '@/contexts/labels';

import Form from './form';

export function SubscribeFormFooter() {
    const t = useTranslate('subscribeDialog');

    const { isSubmitSuccessful } = Form.useState();

    return (
        <footer>
            {!isSubmitSuccessful ? (
                <div className="flex">
                    <Form.SubmitButton>{t('submit')}</Form.SubmitButton>
                </div>
            ) : (
                <div className="space-x-sm bg-success px-md py-sm rounded-xl text-center text-white">
                    {t('success')}
                </div>
            )}
        </footer>
    );
}
